const JobsHeader2 = () => {
    return (
      <header className="flex justify-between items-end mb-12 w-full max-sm:flex-col max-sm:gap-4 max-sm:items-start max-sm:mt-8 max-sm:font-semibold max-sm:mb-8">
        <h1 className="text-5xl leading-[52.8px] max-md:text-4xl max-sm:text-3xl">
          <span className="text-slate-800">JobVacancies</span>
          <span className="text-sky-400">forYou</span>
        </h1>
      </header>
    );
  };
  
  export default JobsHeader2;
  